import {GetViews} from "./GetViews";

export default class CUProducts {
    static init (selector)
    {
        if(!$('#addProductCard, #editProductCard', selector).length)
            return false;

        /** Target the product type selectize and change layout on value */
        $('select[name="product_type"]', selector)[0].selectize.on('change', function (value) {

            if(value === 'simple')
                showSimpleLayout()
            else if(value === 'variable')
                showVariableLayout()
            else if(value === 'virtual')
                showVirtualLayout()

        });

        /**
         * When the update variable button is clicked perform the
         * updating of variables and attributes
         */
        $('#update_variables', selector).on('click', function (e) {

            e.preventDefault();

            let formData = $('#productsForm', selector).clone().find('[data-repeater-list] [data-repeater-item]:first-child').remove().end().serializeArray()

            JsLoadingOverlay.show();


            (async () => {
                /** Re-render the attributes */
                $('#variableAttributesContainer', selector).remove();
                await GetViews.viewGet($('.attributeContainer'), formData);

                /** Re-render variable products */
                formData = $('#productsForm', selector).clone().find('[data-repeater-list] [data-repeater-item]:first-child').remove().end().serializeArray()
                $('#variableProductContainer', selector).remove();
                await GetViews.viewGet($('.variableContainer'), formData);

                $('#attributeChange', selector).remove();
            })().then(() => {

                JsLoadingOverlay.hide();
            });



            // JsLoadingOverlay.hide();
        });

        /**
         * Show which WooCommerce channels the product will sync to based on the
         * currently selected categories. Mirrors the live-sync rule: a product is
         * pushed to a channel when one of its categories is linked to that channel.
         */
        const $syncChannels = $('#productSyncChannels', selector);
        const $categories = $('#categories', selector);

        if ($syncChannels.length && $categories.length && $categories[0].selectize) {

            let syncChannelsTimer = null;

            function renderSyncChannels(channels) {
                const $list = $syncChannels.find('.product-sync-channels-list');

                if (!channels || !channels.length) {
                    $list.html('<small class="text-muted">This product will not sync to any channels.</small>');
                    return;
                }

                $list.html(channels.map(function (channel) {
                    return '<span class="badge badge-primary mr-1">' + $('<div>').text(channel.name).html() + '</span>';
                }).join(''));
            }

            function loadSyncChannels() {
                const categoryIds = $categories[0].selectize.getValue();

                if (!categoryIds || !categoryIds.length) {
                    $syncChannels.find('.product-sync-channels-list').html(
                        '<small class="text-muted">Select categories to see which channels this product will sync to.</small>'
                    );
                    return;
                }

                axios.get($syncChannels.data('src'), {
                    params: {type: 'WooCommerce', categories: categoryIds}
                }).then(response => renderSyncChannels(response.data));
            }

            $categories[0].selectize.on('change', function () {
                clearTimeout(syncChannelsTimer);
                syncChannelsTimer = setTimeout(loadSyncChannels, 300);
            });

            loadSyncChannels();
        }

        function showSimpleLayout() {
            $('[show-if-variable]', selector).addClass('d-none');
            $('[show-if-virtual]', selector).addClass('d-none');
            $('[show-if-simple]', selector).removeClass('d-none');
        }

        function showVariableLayout() {
            $('[show-if-variable]', selector).removeClass('d-none');
            $('[show-if-simple]', selector).addClass('d-none');
            $('[show-if-virtual]', selector).addClass('d-none');
        }

        function showVirtualLayout() {
            $('[show-if-simple]', selector).addClass('d-none');
            $('[show-if-variable]', selector).addClass('d-none');
            $('[show-if-virtual]', selector).removeClass('d-none');
        }
    }
}
